/**
 * Device Context Menu Store
 */

export const state = () => ({})

export const mutations = {}

export const actions = {
  // 각 관리자별 관리 장비 데이터(장비 트리 기반) context-menu REST API 용(store 저장 하지 않음)
  async getTotalDeviceData () {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      res = await this.$axios.$get('/api/sm/devices-tree', {
        params: {
          only_group_yn: 0,
          only_config_yn: 0,
          tams_yn: 1,
          slave_yn: 1,
          except_mon_node_yn: 0,
          only_policy_mng_yn: 0,
          onlyTamsYn: 0,
          event_code_yn: 1
        },
        loading: false,
        ignoreHaPrefix: true
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async checkDeviceConnection ({ state }, { ip, port }) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const api = `/api/sm/devices/connect/${ip}/${port}`
      res = await this.$axios.$get(api, {
        loading: false,
        ignoreHaPrefix: true
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}

export const strict = false
